import { FundingSource } from 'reduxState/store/boostedOffers/types';

export const FUNDING_SOURCE_LABELS: Record<FundingSource, string> = {
  PARTNER: 'Partner',
  MERCHANT: 'Merchant',
  WILDFIRE: 'Wildfire',
  UNKNOWN: 'Unknown',
};

export const SELECTABLE_FUNDING_SOURCES: FundingSource[] = ['PARTNER', 'MERCHANT', 'WILDFIRE'];

export const FUNDING_SOURCE_OPTIONS = SELECTABLE_FUNDING_SOURCES.map(value => ({
  value,
  label: FUNDING_SOURCE_LABELS[value],
}));
